import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import PageTabHeader from "@/App/Layouts/PageBody/PageTabHeader";
import { ViewVariant } from "@/common/ts/layout";
import { VehicleDto } from "@/core/api/generated/v1";

import VehicleActualStateView from "../../VehicleActualState/VehicleActualStateView";

interface Props {
  vehicle: VehicleDto;
}
export default function VehicleActualStateTabContent({ vehicle }: Props) {
  return (
    <PageTabContent>
      <VehicleActualStateView
        vehicleId={vehicle.id || ""}
        displayProps={{
          header: true,
          breadcrumbs: false,
          vehicle: false,
          viewVariant: ViewVariant.Tab,
        }}
        headerProps={{
          withLink: false,
          title: <PageTabHeader title={"Actual state"} subtitle2={undefined} />,
          typographyProps: {},
        }}
      />
    </PageTabContent>
  );
}
